export interface Stepper {
  activeStep: number;
}

export const Stepper = undefined;
